/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import { aviMediumDateFormatWithSec } from 'ng/modules/core/pipes/avi-date.pipe';

import { SchemaService } from 'ajs/modules/core/services/schema-service/schema.service';

import { FilterOperatorType, VsAppProfileType } from '../../../logs.types';
import { TrafficLogCinematicStore } from '../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';
import { ITrafficLogsStates, TrafficLogsStore } from '../../traffic-logs/traffic-logs.store';
import * as l10n from './log-cinematic-section-summary.l10n';

import './log-cinematic-section-summary.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Component for displaying Summary section in a traffic log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-section-summary',
    templateUrl: './log-cinematic-section-summary.component.html',
})
export class LogCinematicSectionSummaryComponent {
    public readonly vsAppProfileType$ = this.logsStore.vsAppProfileType$;

    public readonly VsAppProfileType = VsAppProfileType;

    public readonly applicationLog$ = this.logCinematicStore.applicationLog$;

    public readonly connectionLog$ = this.logCinematicStore.connectionLog$;

    public readonly ssl$ = this.logCinematicStore.ssl$;

    public readonly hasAuthenticationLogs$ = this.logCinematicStore.hasAuthenticationLogs$;

    public readonly icapLog$ = this.logCinematicStore.icapLog$;

    public readonly wafLog$ = this.logCinematicStore.wafLog$;

    public readonly botManagementLog$ = this.logCinematicStore.botManagementLog$;

    public readonly datascriptInfo$ = this.logCinematicStore.datascriptInfo$;

    public readonly FilterOperatorType = FilterOperatorType;

    /**
     * Format string that specifies date transformation to seconds.
     */
    public readonly timeFormat = aviMediumDateFormatWithSec;

    /**
     * Get global keys from source bundles for template usage.
     */
    public readonly globalL10nKeys = globalL10nKeys;

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    /**
     * Hash from enum values to the corresponding translated labels.
     */
    public readonly enumLabelHash = {
        ...this.schemaService.getEnumValueLabelsHash('DnsRecordType'),
        ...this.schemaService.getEnumValueLabelsHash('Protocol'),
    };

    constructor(
        public readonly logCinematicStore: TrafficLogCinematicStore,
        private readonly schemaService: SchemaService,
        private readonly logsStore: TrafficLogsStore<ITrafficLogsStates>,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
